export default __webpack_public_path__ + "static/media/img-count-3-line@3x.ce6c8fcb.png";